export default __webpack_public_path__ + "static/media/gamingPlatformSelected.9f247ac9.svg";